var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#606060", fillRule: "evenodd", d: "M12.707 12l5.147 5.146c.471.472-.236 1.179-.708.708L12 12.707l-5.146 5.147c-.472.471-1.179-.236-.708-.708L11.293 12 6.146 6.854c-.471-.472.236-1.179.708-.708L12 11.293l5.146-5.147c.472-.471 1.179.236.708.708L12.707 12z" })
  );
});